import StatsGrid from './StatsGrid';
import ReviewQueue from './ReviewQueue';
import Footer from '../common/Footer';
import { useTheme } from '../../context/ThemeContext';
import { getThemeClasses } from '../../utils/theme';

const Dashboard = () => {
  const { isDarkMode } = useTheme();
  const theme = getThemeClasses(isDarkMode);

  return (
    <div className={`min-h-screen ${theme.bgPrimary} flex flex-col`}>
      <div className="flex-1">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          {/* Page Header */}
          <div className="mb-8">
            <h2 className={`text-2xl font-bold ${theme.textPrimary}`}>Auditor Dashboard</h2>
            <p className={`${theme.textTertiary} mt-1`}>
              Review flagged payments and manage your audit queue
            </p>
          </div>

          {/* Stats Grid */}
          <div className="mb-8">
            <StatsGrid />
          </div>

          {/* Review Queue */}
          <ReviewQueue />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Dashboard;
